import React from 'react';
import { createGlobalStyle } from 'styled-components';

const CompleteLoadingTransition = ({ appFeaturesLoaded }) => {
  const isRequestResolved = appFeaturesLoaded === 'succeeded' || appFeaturesLoaded === 'failed';
  return isRequestResolved ? <CompleteLoading /> : null;
};

export const CompleteLoading = createGlobalStyle`
  .loading-box {
      display: none;
  }
`;

export default CompleteLoadingTransition;
